module.exports = __webpack_public_path__ + "static/img/gsj.6e38a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/gsj.png
// module id = fcSr
// module chunks = 1